import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); // 👈 loading state

  useEffect(() => {
    const access = localStorage.getItem("access");
    if (access) {
      setIsAuthenticated(true);
    }
    setLoading(false); // 👈 finish loading once check is done
  }, []);

  const login = () => {
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.clear();
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};


// src/contexts/AuthContext.js

// import React, { createContext, useContext, useState, useEffect } from "react";

// const AuthContext = createContext();

// export const useAuth = () => {
//   return useContext(AuthContext);
// };

// export const AuthProvider = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [userRole, setUserRole] = useState("public"); // Default to 'public'
//   const [kycStatus, setKycStatus] = useState("not_submitted"); // Default KYC status
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const access = localStorage.getItem("access");
//     const storedUserRole = localStorage.getItem("userRole");
//     const storedKycStatus = localStorage.getItem("kycStatus");

//     if (access) {
//       setIsAuthenticated(true);
//       setUserRole(storedUserRole || "user"); // Default to 'user' if role not set
//       setKycStatus(storedKycStatus || "not_submitted"); // Default KYC status
//     } else {
//       // If no access token, ensure user is public
//       setIsAuthenticated(false);
//       setUserRole("public");
//       setKycStatus("not_submitted");
//     }
//     setLoading(false);
//   }, []);

//   const login = (role, kycStat = "not_submitted") => {
//     // Assuming 'access' token is stored in localStorage by your actual login API call
//     // localStorage.setItem("access", "your_access_token"); // This should come from your API response
//     localStorage.setItem("userRole", role);
//     localStorage.setItem("kycStatus", kycStat); // Initial KYC status on login
//     setIsAuthenticated(true);
//     setUserRole(role);
//     setKycStatus(kycStat);
//   };

//   const logout = () => {
//     localStorage.removeItem("access");
//     localStorage.removeItem("refresh");
//     localStorage.removeItem("userRole"); // Remove userRole on logout
//     localStorage.removeItem("kycStatus"); // Remove kycStatus on logout
//     // localStorage.clear(); // Use this if you want to clear ALL localStorage items
//     setIsAuthenticated(false);
//     setUserRole("public");
//     setKycStatus("not_submitted");
//   };

//   const updateKycStatus = (status) => {
//     setKycStatus(status);
//     localStorage.setItem("kycStatus", status);
//     if (status === "approved") {
//       setUserRole("vendor"); // If KYC approved, update role to vendor
//       localStorage.setItem("userRole", "vendor");
//     }
//   };

//   // Derived states for easier checks
//   const isPublic = !isAuthenticated;
//   const isRegularUser = isAuthenticated && userRole === "user";
//   const isVendor = isAuthenticated && userRole === "vendor";
//   const canPostDeals = isVendor && kycStatus === "approved";
//   const canPostActivities = isAuthenticated && (userRole === "user" || userRole === "vendor");


//   const contextValue = {
//     isAuthenticated,
//     userRole,
//     kycStatus,
//     loading,
//     login,
//     logout,
//     updateKycStatus,
//     isPublic,
//     isRegularUser, // Renamed from isUser to avoid confusion with public user
//     isVendor,
//     canPostDeals,
//     canPostActivities,
//   };

//   return (
//     <AuthContext.Provider value={contextValue}>
//       {children}
//     </AuthContext.Provider>
//   );
// };